import React, { useEffect, useState } from "react";
import generatePDF from "../services/HuntersReportGenerator";
import axios from "axios";
import HuntersComponent from "./HuntersComponent";
import { PDFViewer } from '@react-pdf/renderer';
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font, Svg } from '@react-pdf/renderer';
import "./styles.css";

export default function TrophyReport(props) {

  useEffect(() => { 
  
  });

  var today = new Date();

  const datum ='Datum: ' +  today.getDate()  + '.' + (today.getMonth() + 1) + '.' + today.getFullYear() + '. god.';

Font.register({
  family: "Roboto",
  src:
    "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf"
});

const styles = StyleSheet.create({
  page: {
    fontFamily: "Roboto"
  },
  body: {
    paddingTop: 50,
    paddingBottom: 65,
    paddingHorizontal: 30,
	fontFamily: "Roboto", 
	fontSize: 10,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Roboto'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Roboto'
  },
  textdata: {
    margin: 5,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 180,
  },
  text: {
    margin: 5,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmedium: {
    margin: 3,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmediumlarge: {
    margin: 12,
    fontSize: 20,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  textbig: {
    margin: 12,
    fontSize: 28,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  officer: {
	paddingTop: 70,
    fontSize: 12,
	margin: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
	left: 150,
  },
  officertext: {
    margin: 0,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Roboto',
  },
  mp: {
    position: 'absolute',
    fontSize: 12,
    bottom: 100,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
  },
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid",  
    borderRightWidth: 0, 
	borderLefttWidth: 0, 
    borderTopWidth: 1,
	borderBottomWidth: 1,
  }, 
  tableRow: { 
    margin: "0", 
    flexDirection: "row",
	 borderWidth: 1,
  }, 
  tableCol: { 
    width: "10%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 1, 
    borderTopWidth: 1 
  }, 
  tableColLong: { 
    width: "15%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 1, 
    borderTopWidth: 1 
  },
  tableColShort: { 
    width: "10%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 1, 
    borderTopWidth: 1 
  },
  tableCell: { 
    margin: "auto", 
    marginTop: 5, 
    fontSize: 10 
  },
});

const TrophyReport = () => (
  <Document>
    <Page size="A4" orientation="portrait" scale={0.5} style={styles.body} wrap>
	
	<Text size="A4" style={styles.textmedium}>{props.trophy.hunter.huntingclub.huntingunion.naziv}</Text>
	
	<Text size="A4" style={styles.textmedium}>{props.trophy.hunter.huntingclub.naziv} {props.trophy.hunter.huntingclub.mjesto}</Text>
	
	<Text size="A4" style={styles.textmedium}>Broj: {props.trophy.broj}</Text>
	
	<Text size="A4" style={styles.textmedium}>{datum}</Text>

	<Svg style={styles.text} width="800" height="100" viewBox="0 0 800 100">
		<Text style={styles.textmediumlarge} x="200" y="80">Trofejni list</Text>
	</Svg>	
	
	<Text size="A4" style={styles.textdata}>
        Divljač: {props.trophy.naziv}
    </Text>
	
    <Text size="A4" style={styles.textdata}>
        Broj poena: {props.trophy.brojpoena}
    </Text>
	
	<Text size="A4" style={styles.textdata}>
        Lokacija: {props.trophy.lokacija}
    </Text>
	
	<Text size="A4" style={styles.textdata}>
        Datum: {props.trophy.datum}
    </Text>
	
	<Text size="A4" style={styles.textdata}>
        Lovačko društvo: {props.trophy.hunter.huntingclub.naziv}
    </Text>
	
	<Text size="A4" style={styles.textdata}>
        Strijelac: {props.trophy.hunter.ime} {props.trophy.hunter.prezime}
    </Text>
	
	
	
	
	<Text size="A4" style={styles.text}>
        Trofejni list se izdaje u svrhu transporta trofeja.
    </Text>
	  
    <View size="A4" style={styles.officer}>	 
	<Text size="A4" style={styles.officertext} >{props.trophy.hunter.huntingclub.sekretar}</Text>
	<Text size="A4" style={styles.officertext} >______________________________</Text>
	<Text size="A4" style={styles.officertext} >(Sekretar udruženja)</Text>
	</View>	
	
	<Text size="A4" style={styles.mp}>
		M.P.
	</Text>

    <Text
        style={styles.pageNumber}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        fixed
    />
    </Page>
  </Document>
  );
  
  return (
    <div className = "child">
	{true &&
	<PDFViewer className = "child">
		<TrophyReport />
	</PDFViewer>
	}
    </div>
  );
};